import React, { useLayoutEffect } from 'react';
import App from './App';
import { useAuth } from './contexts/AuthContext';
import { useInterfaceLoading } from './contexts/GlobalFeatures';
import BunnyLoading from './components/BunnyLoading';
import { getUserPermissions } from './utils/userProfileContextHelpers';
import { useHotelOwner } from './contexts/HotelOwnerContext';
import useUserProfile from './customHooks/useUserProfile';
import { adaptHotelOwnerToState } from './services/hotelOwner/hotelOwnerAdapters';
import { useNotification } from './contexts/NotificationsContext';
import { FeedbackMessages } from './utils/commonVariables/messages';
import { useAppConfiguration } from './contexts/AppConfigurationContext';
import { adaptAppConfiguration } from './utils/appConfiguration/appConfigurationUtils';

//  gestiona la autenticación y cargar los primeros datos del usuario / owner antes de renderizar App
const AppGate = () => {
    const { setErrorMessage } = useNotification();
    const { setIsLoadingInterface, isLoadingInterface } = useInterfaceLoading();
    const { checkAuthentication } = useAuth();
    const { getInitialOwnerData, saveOwnerData } = useHotelOwner();
    const { getAppConfiguration, updateAppConfiguration } =
        useAppConfiguration();
    const {
        getInitialProfileData,
        username,
        updateSettings,
        handleProfileData,
    } = useUserProfile();

    useLayoutEffect(() => {
        setIsLoadingInterface(true);
        checkAuthentication()
            .then(async (authenticated: boolean) => {
                if (authenticated) {
                    const [ownerData, userProfile, appConfigKeysData] =
                        await Promise.all([
                            getInitialOwnerData(),
                            getInitialProfileData(),
                            getAppConfiguration(),
                        ]);
                    if (ownerData) {
                        saveOwnerData(adaptHotelOwnerToState(ownerData));
                        const mainUser = {
                            ReadOnly: false,
                            Admin: true,
                            SystemUser: ownerData.SystemUser,
                            MainUser: true,
                        };
                        const users = [...ownerData.Users, mainUser];
                        const permissions = getUserPermissions(username, users);
                        updateSettings({
                            ...permissions,
                        });
                        const appConfig = adaptAppConfiguration(
                            ownerData.ZinantisMembership,
                            appConfigKeysData,
                            ownerData.ConfigurationValues
                        );
                        updateAppConfiguration(appConfig);
                    }

                    if (userProfile) {
                        await handleProfileData(ownerData?.Signed, userProfile);
                    }
                }
            })
            .catch(() => {
                setErrorMessage(FeedbackMessages.COMMON_ERROR);
            })
            .finally(() => {
                setIsLoadingInterface(false);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {isLoadingInterface ? (
                <div className='App'>
                    <BunnyLoading />
                </div>
            ) : (
                <App />
            )}
        </>
    );
};

export default AppGate;
